import {AmplitudePricesCityButtonName, trackAmplitudeButtonClick} from "../../../tracking/amplitude/track_amplitude_button_click";
import {PricesCityAnalyticsLocation} from "./prices_city_analytics";

interface ITrackPricesCityButtonClickParams {
    buttonName: AmplitudePricesCityButtonName;
    /** Label exactly as the user sees it - an area value, a district name, or prev / next for arrows. */
    value: string;
    buttonLink?: string | null;
    location: PricesCityAnalyticsLocation;
}

export const trackPricesCityButtonClick = (params: ITrackPricesCityButtonClickParams) => {
    trackAmplitudeButtonClick({
        buttonName: params.buttonName,
        buttonCategory: params.location,
        itemId: null,
        buttonLink: params.buttonLink ?? null,
        value: params.value
    });
};
import {AmplitudePricesCityButtonName, trackAmplitudeButtonClick} from "../../../tracking/amplitude/track_amplitude_button_click";
import {PricesCityAnalyticsLocation} from "./prices_city_analytics";

interface ITrackPricesCityButtonClickParams {
    buttonName: AmplitudePricesCityButtonName;
    /** Label exactly as the user sees it - an area value, a district name, or prev / next for arrows. */
    value: string;
    buttonLink?: string | null;
    location: PricesCityAnalyticsLocation;
}

export const trackPricesCityButtonClick = (params: ITrackPricesCityButtonClickParams) => {
    trackAmplitudeButtonClick({
        buttonName: params.buttonName,
        buttonCategory: params.location,
        itemId: null,
        buttonLink: params.buttonLink ?? null,
        value: params.value
    });
};
